import { render, staticRenderFns } from "./MemberManage.vue?vue&type=template&id=04d23f0c&scoped=true&"
import script from "./MemberManage.vue?vue&type=script&lang=js&"
export * from "./MemberManage.vue?vue&type=script&lang=js&"
import style0 from "./MemberManage.vue?vue&type=style&index=0&id=04d23f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d23f0c",
  null
  
)

export default component.exports